/**
 * LANGUAGE SELECTOR
 *
 * @version 0.1
 */

import React from 'react';
import reduxStore from './../../reduxStore';
import { FormattedMessage } from 'react-intl';
import { DEFAULT_LANGUAGE, LOCALES } from './../../../scripts/constants';
import commonActions from './../../api/Common.actions';

class LanguageSelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = reduxStore.getState();
        this.changeLanguage = this.changeLanguage.bind(this);

        this.previousLanguage = DEFAULT_LANGUAGE;
        this.displayedLanguage = <FormattedMessage id={LOCALES[this.state.user.preferences.language].id} />
        this.languagesArr = Object.keys(LOCALES);
    }

    componentWillMount() {
        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(reduxStore.getState());
            }
        );
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    changeLanguage(event) {
        let selectedLanguage = event.currentTarget.getAttribute('data-language');
        reduxStore.dispatch({
            type:    'USER_CHANGE_LANGUAGE',
            payload: selectedLanguage
        });
        this.previousLanguage = selectedLanguage;

        let prefs = reduxStore.getState().user.preferences;

        commonActions.updateUserPrefs(
            Object.assign({}, prefs, {language: selectedLanguage})
        );

        this.displayedLanguage = <FormattedMessage id={LOCALES[selectedLanguage].id} />;

    }

    render() {
        return (
            <a className='header__menu-link language'>
                <FormattedMessage
                    id='Entities_Preview_UIText_previewCompanies.language' />: <span>{this.displayedLanguage}</span>
                <ul className='languages-menu'>
                    {
                        this.languagesArr.map((value) => {
                            return (
                                <li className='header__menu-link' key={value} data-language={value}
                                    onClick={this.changeLanguage}>
                                    <FormattedMessage id={LOCALES[value].id} />
                                    {
                                        LOCALES[this.state.user.preferences.language].id === LOCALES[value].id ?
                                            <span className='la-Check checked-symbol'></span> : null
                                    }
                                </li>
                            )
                        })
                    }
                </ul>
            </a>
        )
    }

}

export default LanguageSelector;


// WEBPACK FOOTER //
// ./src/scripts/reusable/LanguageSelector/LanguageSelector.index.jsx